import AsyncButton from '../../../../../../shared/Loading/AsyncButton';

const Buttons = (vm) => {
    const BONDA_ADMIN_URL = 'https://admin.bonda.com/auth/signin';

    const onClick = async (id) => {
        const lostAccess = await vm.losesAccess()
        if (lostAccess) return;
        vm.onTabChange(id);
        vm.setNavOpen(false);
        vm.setMenuOpen(false);
    }

    const validPermission = (permissionCode) => {
        return vm.permission.includes(permissionCode)
    }

    const openExternal = async (url) => {
        const lostAccess = await vm.losesAccess()
        if (lostAccess) return;
        window.open(url, '_blank', 'noopener,noreferrer');
        vm.setNavOpen(false);
        vm.setMenuOpen(false);
    }

    const navBtn = (id, label, access) => {
        if (!validPermission(access)) return null;
        const isActive = vm.activeTab === id;
        const base = 'module-nav-button px-3 py-1 transition border border-personalized rounded-full text-sm md:text-base max-lg:w-full max-lg:rounded-md max-lg:border-transparent max-lg:px-3 max-lg:py-2 max-lg:text-left';
        const activeCls = 'module-nav-active bg-white text-personalized max-lg:bg-purple-50';
        const inactiveCls = 'module-nav-inactive hover:border-white max-lg:text-gray-700 max-lg:hover:border-transparent max-lg:hover:bg-purple-50 max-lg:hover:text-personalized';
        return (
            <li>
            <AsyncButton
                onClick={() => onClick(id)}
                light={isActive || vm.navOpen}
                className={`${base} ${isActive ? activeCls : inactiveCls}`}
                aria-current={isActive ? 'page' : undefined}
            >
                {label}
            </AsyncButton>
            </li>
        );
    };

    const bondaAdminBtn = () => {
        if (!validPermission(11)) return null;
        return (
            <li>
                <AsyncButton
                    onClick={() => openExternal(BONDA_ADMIN_URL)}
                    light={vm.navOpen}
                    className="module-nav-button module-nav-inactive px-3 py-1 transition border border-personalized rounded-full text-sm md:text-base hover:border-white
                        max-lg:w-full max-lg:rounded-md max-lg:border-transparent max-lg:px-3 max-lg:py-2 max-lg:text-left
                        max-lg:text-gray-700 max-lg:hover:border-transparent max-lg:hover:bg-purple-50 max-lg:hover:text-personalized"
                >
                    Bonda Admin
                </AsyncButton>
            </li>
        );
    };

    return {
        navBtn,
        bondaAdminBtn,
    };
};

export default Buttons;
